import { Box } from "@dxp-feed/ui/Box";

const SpaceBar = () => {
  return <Box as="div" className="h-3 lg:h-6"></Box>;
};
export default SpaceBar;
